<template>
	<dialog-component custom-class="suspended-wrap" @close="onClose">
		<p class="suspended-title">{{ SUSPENDED_DIALOG_TEXTS.title }}</p>
		<p class="suspended-description">{{ SUSPENDED_DIALOG_TEXTS.description }}</p>
		<p class="suspended-note">{{ SUSPENDED_DIALOG_TEXTS.note }}</p>

		<div class="suspended-btn-group">
			<base-button :text="plansStore.cta" @click="onGetPro" />
			<base-button :text="LIMIT_DIALOG_PROFILE_CTA" variant="secondary" @click="goToProfile" />
		</div>
	</dialog-component>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import DialogComponent from '@/components/dialogs/DialogComponent.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { usePlansStore } from '@/stores/plans'
import { usePaymentFlow } from '@/composables/usePaymentFlow'
import { LIMIT_DIALOG_PROFILE_CTA, SUSPENDED_DIALOG_TEXTS } from '@/constants/pro'

const emit = defineEmits<{ close: [] }>()

const router = useRouter()
const plansStore = usePlansStore()
const { startCheckout } = usePaymentFlow()

function onClose() {
	emit('close')
}

function goToProfile() {
	onClose()
	router.push('/profile')
}

/**
 * Повторная оплата. Отдельной ручки продления нет: сорванную подписку бэк разруливает
 * на том же POST /billing/checkout, что и первую покупку, — поэтому здесь тот же вызов,
 * что в пейволле, без ветвления по статусу.
 */
function onGetPro() {
	startCheckout('suspended')
	onClose()
}
</script>

<style lang="scss" scoped>
.suspended {
	&-title {
		font: var(--font-title);
		color: var(--text-primary);
		text-align: center;
		margin-bottom: 12px;
	}
	&-description {
		font: var(--font-body-small);
		color: var(--text-secondary);
		text-align: center;
		margin-bottom: 24px;
	}
	&-note {
		font: var(--font-body-small);
		color: var(--text-primary);
		text-align: center;
		padding: 12px;
		border-radius: var(--radius-md);
		background-color: var(--background-secondary);
		width: 100%;
		margin-bottom: 24px;
	}
	&-btn-group {
		display: flex;
		flex-direction: column;
		gap: 12px;
		width: 100%;
		// перебиваем padding: 15px 20px из .btn в BaseButton
		.btn {
			width: 100%;
			padding: 14px 12px;
			min-height: 52px;
		}
	}
}
</style>
